import { Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import { setDocumentTitle } from "@/lib/documentTitle";

import { type A7FIAInstrumentTS } from "./columns";

import { A7FIAInstrumentTSEdit } from "./edit";
import { A7FIAInstrumentsTSTable } from "./table";

export default function A7FIAInstrumentTS() {
  useEffect(() => {
    setDocumentTitle(
      "Quantilia | FIA Instruments Financiers Séries Temporelles",
    );
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<A7FIAInstrumentTSEdit />} />
      <Route index element={<A7FIAInstrumentsTSTable />} />
    </Routes>
  );
}
